import { Observable, Observer, Unsubscribe } from "redux";

export default class AttachmentDispatcher implements Observable<number> {
  private observers: Observer<number>[] = [];

  private lastProgress = -1;

  [Symbol.observable](): Observable<number> {
    return this;
  }

  progressEvent(progressEvent: { loaded: number; total: number }): void {
    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    if (this.lastProgress < progress) {
      this.observers.forEach((observer) => observer.next?.(progress));
      this.lastProgress = progress;
    }
  }

  subscribe(observer: Observer<number>): { unsubscribe: Unsubscribe } {
    if (!this.observers.includes(observer)) {
      this.observers.push(observer);
    }
    return {
      unsubscribe: () => {
        const index = this.observers.indexOf(observer);
        if (index >= 0) {
          this.observers.splice(index, 1);
        }
      },
    };
  }
}
